import type { ApiClientService } from '@fifa-bsm/bo-frontend-shared';

export class BaseApiService {
    client: ApiClientService;

    constructor(client: ApiClientService) {
        this.client = client;
    }
}
